var render = function render(){var _vm=this,_c=_vm._self._c;return (['J', '1225-onboarding-core-v1', 'K'].includes(_vm.onboardingVariant))?_c('div',[_c('div',{attrs:{"id":"express-checkout-element"}})]):_c('div',{ref:"paymentRequestButton",class:{'onboarding-redesign tw-relative': _vm.isOnboardingRedesign},attrs:{"id":"payment-request-button"}})
}
var staticRenderFns = []

export { render, staticRenderFns }